import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Component from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
import IndexPage from 'flarum/forum/components/IndexPage';

/**
 * Renders its children without a wrapper, so both buttons stay direct
 * children of the `.App-primaryControl` list item that core positions in
 * the phone header (same pattern as NotificationList's header controls).
 */
class HeaderControlGroup extends Component {
  view(vnode) {
    return vnode.children;
  }
}

/**
 * Phones: a bell to the left of the "new discussion" button in the header.
 * Hidden from tablet width up via LESS, where the sidebar button stays alone.
 */
export default function addHeaderButton() {
  extend(IndexPage.prototype, 'sidebarItems', function (items) {
    if (!app.session.user || !items.has('newDiscussion')) return;

    const label = app.translator.trans('happydigital-notification-settings.forum.header_button');

    items.setContent(
      'newDiscussion',
      <HeaderControlGroup itemClassName="App-primaryControl">
        <LinkButton
          // Same classes as the "new discussion" button, so any forum theme or
          // custom CSS that styles that button styles the bell identically.
          className="Button Button--primary IndexPage-newDiscussion HappyNotify-headerButton"
          icon="fas fa-bell"
          href={app.route('happyNotifySettings')}
          aria-label={label}
          title={label}
        />
        {items.get('newDiscussion')}
      </HeaderControlGroup>
    );
  });
}
